/**
 * Canonical route paths for the predictions module.
 *
 * `PREDICTIONS_NOTIFICATIONS_ROUTE` is not decoration: it is the gate the
 * app-wide sound mount reads to decide whether this tab is allowed to ring
 * (see `PredictionNotificationSound`). The sidebar nav entry and the sound
 * gate MUST agree on the literal, so it lives here instead of being typed
 * twice — a drift between them would look like "the sound just stopped
 * working" with nothing broken in either file on its own.
 */
export const PREDICTIONS_NOTIFICATIONS_ROUTE = '/predictions/notifications';

/**
 * Is `pathname` the notifications feed?
 *
 * Compares with the trailing slash normalised away. React Router renders the
 * feed for `/predictions/notifications/` just the same, but `location.pathname`
 * keeps the slash — a raw `===` would then look at a tab showing the feed and
 * decide it is not the feed, going silent with nothing on screen to explain
 * it. Reachable from a bookmark, a typed URL or a CDN normalisation.
 */
export function isNotificationsRoute(pathname: string): boolean {
  const normalised =
    pathname.length > 1 && pathname.endsWith('/')
      ? pathname.slice(0, -1)
      : pathname;
  return normalised === PREDICTIONS_NOTIFICATIONS_ROUTE;
}
